/** `POST /ai/agents/name` (`bobcat/src/server-only/ai/name-agents.ts`). */
import { bobcatApiUrl } from '../../utils/bobcat-api';
export interface AgentToName {
  key: string;
  current: string;
  nodeNames: string[];
}

export const nameSuggestedAgents = async (
  agents: AgentToName[],
  signal?: AbortSignal
): Promise<Record<string, string>> => {
  const response = await fetch(bobcatApiUrl('/ai/agents/name'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ agents }),
    signal,
  });
  const json = (await response.json().catch(() => null)) as {
    names?: Record<string, string>;
    detail?: string;
    error?: string;
  } | null;
  if (!response.ok) {
    throw new Error(json?.detail ?? json?.error ?? response.statusText);
  }
  return json?.names ?? {};
};
